import { useEffect, useState } from "react";
import {
  useCancelTerminalPaymentSession,
  useCreateTerminalPaymentSession,
  // useRetryTerminalPaymentSession,
} from "../../../../../hooks/api/mutations/useTerminals";
import { useCart } from "../../../../../hooks/useCart";
import { useGetTerminalPaymentSession } from "../../../../../hooks/api/queries/useTerminals";
import { useGetSellmodeAssignedTerminal } from "../../../../../hooks/useGetSellmodeAssignedTerminal";

export const useCardListener = ({
  amount = 0,
  paymentProvider,
  paymentMethod = "card",
  closeModal = () => {},
}) => {
  const { isCreatingOrder, submitOrder } = useCart({});
  const { assignTerminalProviders, assignedTerminal } =
    useGetSellmodeAssignedTerminal({});
  const terminalDetails = assignTerminalProviders?.[paymentProvider];

  const [paymentStatus, setPaymentStatus] = useState("PENDING");
  const [countDown, setCountDown] = useState(5);
  const [hitThirdParty, setHitThirdParty] = useState(false);

  const {
    mutate: createCheckoutSession,
    isLoading,
    data: sessionDetails,
  } = useCreateTerminalPaymentSession({ id: terminalDetails?.id });

  // const { mutate: retryCheckoutSession, isLoading: isRetrying } =
  //   useRetryTerminalPaymentSession({
  //     id: terminalDetails?.id,
  //   });

  const { mutate: cancelCheckoutSession, isLoading: isCanceling } =
    useCancelTerminalPaymentSession({ id: terminalDetails?.id });

  const {
    data: sessionStatusDetails,
    isFetching: isCheckingStatus,
    refetch: refetchPaymentSession,
  } = useGetTerminalPaymentSession({
    transaction_id: sessionDetails?.id,
    terminal_id: terminalDetails?.id,
    paymentStatus,
    hitThirdParty,
    onSuccess: () => setHitThirdParty(false),
  });

  const proceedToNext = () => {
    submitOrder({
      paymentProps: {
        payment_provider: paymentProvider?.toLowerCase(),
        payment_reference: sessionStatusDetails?.provider_reference,
      },
    });
  };

  // const retryTransaction = () => {
  //   retryCheckoutSession(
  //     {
  //       transaction_id: sessionDetails?.id,
  //     },
  //     { onSuccess: () => setPaymentStatus("PENDING") },
  //   );
  // };

  const cancelTransaction = () => {
    cancelCheckoutSession(
      {
        transaction_id: sessionDetails?.id,
      },
      { onSettled: () => closeModal() },
    );
  };

  const triggerSessionCreation = () => {
    createCheckoutSession(
      {
        total_amount: amount,
        payment_method: paymentMethod,
      },
      {
        onSuccess: (res) => setPaymentStatus(res?.status),
      },
    );
  };

  // step 1
  useEffect(() => {
    if (assignedTerminal) triggerSessionCreation();
  }, [assignedTerminal]);

  // step 2
  useEffect(() => {
    if (!sessionStatusDetails) return;

    setPaymentStatus(sessionStatusDetails?.status);
  }, [sessionStatusDetails]);

  // step 3
  useEffect(() => {
    if (paymentStatus !== "PAID") return;

    const timer = setInterval(() => {
      setCountDown((prev) => {
        if (prev <= 1) {
          clearInterval(timer); // Stop the timer when count reaches 0
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    // Cleanup the interval on component unmount or dependency change
    return () => clearInterval(timer);
  }, [paymentStatus]);

  // step 4
  useEffect(() => {
    if (countDown === 0) proceedToNext();
  }, [countDown]);

  // tell the backend to hit third party DB for payment status
  useEffect(() => {
    if (hitThirdParty) refetchPaymentSession();
  }, [hitThirdParty]);

  return {
    sessionDetails,
    sessionStatusDetails,
    isLoading,
    paymentStatus,
    countDown,
    isCreatingOrder,
    hitThirdParty,
    isCheckingStatus,
    terminalDetails,
    // isRetrying,
    isCanceling,
    cancelTransaction,
    // retryTransaction,
    setHitThirdParty,
    setCountDown,
    triggerSessionCreation,
    proceedToNext,
  };
};
